"use client";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { memo } from "react";
import { PricingPlansProps } from "./types";
import { PricingPlans as PricingPlansCards } from "@/components/screen/global-components/pricing";

const PricingPlans = ({ className, ...rest }: PricingPlansProps) => {
  return (
    <section
      className={cn(
        "section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero lg:bg-[#fcfcfd]",
        className
      )}
      {...rest}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 place-content-start py-12 gap-6 lg:gap-12 lg:py-20">
          <div className="grid grid-cols-1 text-center place-content-start gap-4 lg:gap-2 w-full max-w-[800] mx-auto">
            <Typography
              variant="heading4"
              className="text-semantic-text-primary lg:text-[#1b1f3b] lg:text-[54px]/20 lg:font-medium lg:leading-[135%] w-full max-w-[620] mx-auto"
            >
              <h1>Translation rates priced to help you grow</h1>
            </Typography>
            <Typography
              variant="subHeadingSm"
              className="text-gray-500 lg:gray-600 lg:text-xl lg:leading-[150%] lg:font-normal"
              asChild
            >
              <p>Get high-quality online translation services without compromising on speed or cost.</p>
            </Typography>
          </div>
          <PricingPlansCards />
        </div>
      </div>
    </section>
  );
};

export default memo(PricingPlans);
